/**
 * Blocks dangerous file types in chat (upload + display/download).
 * Checks every dot-separated extension (e.g. evil.pdf.exe).
 */

const BLOCKED_EXTENSIONS = new Set([
    'ade',
    'adp',
    'apk',
    'app',
    'application',
    'bat',
    'bin',
    'cab',
    'chm',
    'class',
    'cmd',
    'com',
    'command',
    'cpl',
    'crt',
    'csh',
    'deb',
    'dll',
    'dmg',
    'drv',
    'exe',
    'gadget',
    'hta',
    'inf',
    'ins',
    'inx',
    'ipa',
    'isu',
    'jar',
    'job',
    'jse',
    'ksh',
    'lnk',
    'msc',
    'msi',
    'msp',
    'mst',
    'msh',
    'msh1',
    'msh2',
    'mshxml',
    'msh1xml',
    'msh2xml',
    'osx',
    'out',
    'paf',
    'pif',
    'pkg',
    'prg',
    'ps1',
    'ps1xml',
    'ps2',
    'ps2xml',
    'psc1',
    'psc2',
    'reg',
    'rgs',
    'rpm',
    'run',
    'scr',
    'sct',
    'sh',
    'shb',
    'shs',
    'sys',
    'tcsh',
    'vb',
    'vbe',
    'vbs',
    'vbscript',
    'vbx',
    'vxd',
    'workflow',
    'ws',
    'wsc',
    'wsf',
    'wsh',
    'xll',
    'zsh',
]);

const BLOCKED_MIME_EXACT = new Set([
    'application/x-msdownload',
    'application/x-msdos-program',
    'application/x-dosexec',
    'application/x-executable',
    'application/x-csh',
    'application/x-sh',
    'application/x-shellscript',
    'application/x-bat',
    'application/x-msdos-windows',
    'text/x-vbscript',
    'application/x-vbscript',
    'application/vnd.microsoft.portable-executable',
]);

const BLOCKED_MIME_PREFIXES = [
    'application/x-ms-',
    'application/vnd.microsoft.',
];

export function hasBlockedExtension(filename: string): boolean {
    const base = filename.split(/[/\\]/).pop() ?? '';
    const lower = base.toLowerCase();
    const parts = lower.split('.');
    for (let i = 1; i < parts.length; i++) {
        if (BLOCKED_EXTENSIONS.has(parts[i])) {
            return true;
        }
    }
    return false;
}

export function isBlockedChatMediaFile(file: {
    name: string;
    type?: string;
}): boolean {
    if (!file?.name) {
        return false;
    }
    if (hasBlockedExtension(file.name)) {
        return true;
    }
    const mime = (file.type ?? '').trim().toLowerCase();
    if (!mime) {
        return false;
    }
    if (BLOCKED_MIME_EXACT.has(mime)) {
        return true;
    }
    if (BLOCKED_MIME_PREFIXES.some(p => mime.startsWith(p))) {
        return true;
    }
    return false;
}
